import { useSettingsStore } from '../store'
import { HourConfigField } from './HourConfigField'

export function KybHoursTab() {
  const { hourSettings, updateKybHours } = useSettingsStore()
  const kyb = hourSettings.kyb

  return (
    <div className="space-y-6">
      {/* Base Setup */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Base Setup</h4>
        <HourConfigField
          label="KYB Base Setup"
          value={kyb.baseSetup}
          onChange={(v) => updateKybHours('baseSetup', v)}
          description="Initial KYB configuration"
        />
      </div>

      {/* Australian Checks */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Australian Business Checks</h4>
        <HourConfigField
          label="KYB Check"
          value={kyb.kybCheck}
          onChange={(v) => updateKybHours('kybCheck', v)}
          description="Basic business verification"
        />
        <HourConfigField
          label="AML Standard"
          value={kyb.amlStandard}
          onChange={(v) => updateKybHours('amlStandard', v)}
          description="Business AML screening"
        />
        <HourConfigField
          label="AML Enhanced"
          value={kyb.amlEnhanced}
          onChange={(v) => updateKybHours('amlEnhanced', v)}
          description="Enhanced business AML"
        />
        <HourConfigField
          label="ASIC Information"
          value={kyb.asicInfo}
          onChange={(v) => updateKybHours('asicInfo', v)}
          description="ASIC registry lookup"
        />
        <HourConfigField
          label="UBO Discovery"
          value={kyb.ubo}
          onChange={(v) => updateKybHours('ubo', v)}
          description="Ultimate Beneficial Owner"
        />
        <HourConfigField
          label="Credit Score"
          value={kyb.creditScore}
          onChange={(v) => updateKybHours('creditScore', v)}
          description="Business credit check"
        />
        <HourConfigField
          label="Payment Predictor"
          value={kyb.paymentPredictor}
          onChange={(v) => updateKybHours('paymentPredictor', v)}
          description="Payment behavior analysis"
        />
        <HourConfigField
          label="Adverse Information"
          value={kyb.adverseInfo}
          onChange={(v) => updateKybHours('adverseInfo', v)}
          description="Adverse media screening"
        />
      </div>

      {/* Role Checks */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Role-based Checks</h4>
        <HourConfigField
          label="Directors"
          value={kyb.roleDirectors}
          onChange={(v) => updateKybHours('roleDirectors', v)}
          description="Director verification"
        />
        <HourConfigField
          label="Shareholders"
          value={kyb.roleShareholders}
          onChange={(v) => updateKybHours('roleShareholders', v)}
          description="Shareholder verification"
        />
        <HourConfigField
          label="Beneficial Owners"
          value={kyb.roleBeneficialOwners}
          onChange={(v) => updateKybHours('roleBeneficialOwners', v)}
          description="Beneficial owner verification"
        />
      </div>

      {/* Entity Types & International */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Entity & International</h4>
        <HourConfigField
          label="Per Entity Type"
          value={kyb.perEntityType}
          onChange={(v) => updateKybHours('perEntityType', v)}
          description="Hours per additional entity type"
        />
        <HourConfigField
          label="International Per Country"
          value={kyb.internationalPerCountry}
          onChange={(v) => updateKybHours('internationalPerCountry', v)}
          description="Hours per international country"
        />
      </div>

      {/* Advanced Features */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Advanced Features</h4>
        <HourConfigField
          label="Trust Analyser"
          value={kyb.trustAnalyserSetup}
          onChange={(v) => updateKybHours('trustAnalyserSetup', v)}
          description="Trust analyser configuration"
        />
        <HourConfigField
          label="Onboarding Form"
          value={kyb.onboardingFormSetup}
          onChange={(v) => updateKybHours('onboardingFormSetup', v)}
          description="KYB onboarding form setup"
        />
        <HourConfigField
          label="Onboarding Form Branding"
          value={kyb.onboardingFormBranding}
          onChange={(v) => updateKybHours('onboardingFormBranding', v)}
          description="Custom branding for onboarding form"
        />
        <HourConfigField
          label="AML Entity Screening"
          value={kyb.amlEntityScreening}
          onChange={(v) => updateKybHours('amlEntityScreening', v)}
          description="AML screening for business entities"
        />
        <HourConfigField
          label="UBO Workflow Setup"
          value={kyb.uboWorkflowSetup}
          onChange={(v) => updateKybHours('uboWorkflowSetup', v)}
          description="UBO consent and SMS workflow configuration"
        />
        <HourConfigField
          label="Aging Setup"
          value={kyb.agingSetup}
          onChange={(v) => updateKybHours('agingSetup', v)}
          description="KYB aging/re-verification configuration"
        />
      </div>
    </div>
  )
}
